// Match Play — ported verbatim from GolfGamesScorecard's calcMatchPlay
// (utils/scoring.ts). 1v1 holes-up: lower score wins the hole, halved on a tie.
export function calcMatchPlay(p1, p2) {
  let p1Up = 0
  const results = p1.scores.map((s, i) => {
    const s2 = p2.scores[i]
    if (s === null || s === undefined || s2 === null || s2 === undefined) return null
    if (s < s2) { p1Up++; return 'p1' }
    if (s > s2) { p1Up--; return 'p2' }
    return 'halved'
  })
  return { p1Up, results, leader: p1Up > 0 ? p1.name : p1Up < 0 ? p2.name : 'Tied' }
}
